import { Breadcrumbs, Link, Typography } from '@mui/material';
import colors from '../../../../assets/theme/base/colors';
import { useHistory } from 'react-router-dom';
const { primary } = colors;

interface IProps {
    titles: string[];
    hrefs: string[];
    currentLinkIndex: number;
}
export const BreadCrumb = (props: IProps) => {

    const history = useHistory();
    const handleClick = (href: string) => {
        history.push(href)
    }

    return (
        <div role="presentation">
            <Breadcrumbs aria-label="breadcrumb" sx={{ mb: '10px' }}>
                {props.titles.map((title, index) => (
                    <div
                        style={{ cursor: "pointer" }}
                        key={index}
                        onClick={() => (index !== props.currentLinkIndex && handleClick(props.hrefs[index]))}
                    >
                        <Typography
                            variant="body2"
                            component="div"
                            sx={{
                                color: index === props.currentLinkIndex ? 'inherit' : primary.main,
                                textDecoration: 'none',
                                '&:hover': {
                                    textDecoration: 'underline',
                                },
                            }}
                        >
                            {title}
                        </Typography>
                    </div>
                ))}
            </Breadcrumbs>

        </div>
    );
}

